export default __webpack_public_path__ + "static/media/Taste My Flaming Bat.0b34c11a.png";